<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { FlowTravelDatesWidgetQC } from '@/widgets/Flow'

  useApiRequestsAbort()
</script>

<template>
  <FlowTravelDatesWidgetQC />
</template>
